import { render } from "./MfCalendar.vue?vue&type=template&id=13b180b2&scoped=true"
import script from "./MfCalendar.vue?vue&type=script&lang=js"
export * from "./MfCalendar.vue?vue&type=script&lang=js"

import "./MfCalendar.vue?vue&type=style&index=0&id=13b180b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b180b2"]])

export default __exports__